// const pic = 'http://212.129.154.169/'
const url = 'fileservice/oss/txyun/uploadE'

export function getPicUrl() {
  return window.location.protocol + '//' + window.location.host + window.location.pathname + url
}
